import Api from '../api/Api';
import resolve from '../util/Configuracao';
import { format } from 'date-fns';
class ItemTabelaApi extends Api {
  async consultarTabelas () {
    try {
      const urlConsultarTabelas = resolve('urlConsultarTabelas');
      const response = await this.fetch(urlConsultarTabelas);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarTiposDeItem () {
    try {
      const urlConsultarTiposDeItem = resolve('urlConsultarTiposDeItem');
      const response = await this.fetch(urlConsultarTiposDeItem);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarItens (codTabela, codItem, desItem, codTipo, indApenasUnimed) {
    let itens = [];
    let arrayVigencias = [];
    const nf = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    try {
      const urlConsultarItens = resolve('urlConsultarItens') +
      codTabela + '/' +
      codItem + '/' +
      desItem + '/' +
      codTipo + '/' +
      indApenasUnimed;
      const { data } = await this.fetch(urlConsultarItens);
      data.map(res => {
        const { codItem, desItem, tipoItem, tabela, capitulo, grupo, subGrupo, txtObservacao, vigencias, codItemTabela, codTabela } = res;
        for (var i = 0; i < vigencias.length; i++) {
          if (tabela !== 'Tabela SIMPRO'){
            if (vigencias[i].indCancelado === 'S') {
              if (vigencias[i].dtaFim === null) {
                arrayVigencias.push('*Cancelada* Desde ' + format(new Date(vigencias[i].dtaInicio), 'DD/MM/YYYY') + ' - ' + nf.format(vigencias[i].valVigencia) + ' - ' + vigencias[i].grupoPrestador);
              } else {
                arrayVigencias.push('*Cancelada* De ' + format(new Date(vigencias[i].dtaInicio), 'DD/MM/YYYY') + ' até ' + format(new Date(vigencias[i].dtaFim), 'DD/MM/YYYY') + ' - ' + nf.format(vigencias[i].valVigencia) + ' - ' + vigencias[i].grupoPrestador);
              }
            } else {
              if (vigencias[i].dtaFim === null) {
                arrayVigencias.push('* Desde ' + format(new Date(vigencias[i].dtaInicio), 'DD/MM/YYYY') + ' - ' + nf.format(vigencias[i].valVigencia) + ' - ' + vigencias[i].grupoPrestador);
              } else {
                arrayVigencias.push('* De ' + format(new Date(vigencias[i].dtaInicio), 'DD/MM/YYYY') + ' até ' + format(new Date(vigencias[i].dtaFim), 'DD/MM/YYYY') + ' - ' + nf.format(vigencias[i].valVigencia) + ' - ' + vigencias[i].grupoPrestador);
              }
            }
          } else {
            if (vigencias[i].indCancelado === 'S') {
              if (vigencias[i].dtaFim === null) {
                if (vigencias[i].valIntegral !== null) {
                  arrayVigencias.push('*Cancelada* Desde ' + format(new Date(vigencias[i].dtaInicio), 'DD/MM/YYYY') + ' - ' + nf.format(vigencias[i].valVigencia) + ' - Integral: ' +  nf.format(vigencias[i].valIntegral) +  ' - ' + vigencias[i].grupoPrestador);
                } else {
                  arrayVigencias.push('*Cancelada* Desde ' + format(new Date(vigencias[i].dtaInicio), 'DD/MM/YYYY') + ' - ' + nf.format(vigencias[i].valVigencia) + ' - ' + vigencias[i].grupoPrestador);
                }
              } else {
                if (vigencias[i].valIntegral !== null) {
                  arrayVigencias.push('*Cancelada* De ' + format(new Date(vigencias[i].dtaInicio), 'DD/MM/YYYY') + ' até ' + format(new Date(vigencias[i].dtaFim), 'DD/MM/YYYY') + ' - ' + nf.format(vigencias[i].valVigencia) + ' - Integral: ' +  nf.format(vigencias[i].valIntegral) + ' - ' + vigencias[i].grupoPrestador);
                } else {
                  arrayVigencias.push('*Cancelada* De ' + format(new Date(vigencias[i].dtaInicio), 'DD/MM/YYYY') + ' até ' + format(new Date(vigencias[i].dtaFim), 'DD/MM/YYYY') + ' - ' + nf.format(vigencias[i].valVigencia) + ' - ' + vigencias[i].grupoPrestador);
                }

              }
            } else {
              if (vigencias[i].dtaFim === null) {
                if (vigencias[i].valIntegral !== null) {
                  arrayVigencias.push('* Desde ' + format(new Date(vigencias[i].dtaInicio), 'DD/MM/YYYY') + ' - ' + nf.format(vigencias[i].valVigencia) + ' - Integral: ' +  nf.format(vigencias[i].valIntegral) + ' - ' + vigencias[i].grupoPrestador);
                } else {
                  arrayVigencias.push('* Desde ' + format(new Date(vigencias[i].dtaInicio), 'DD/MM/YYYY') + ' - ' + nf.format(vigencias[i].valVigencia) + ' - ' + vigencias[i].grupoPrestador);
                }
              } else {
                if (vigencias[i].valIntegral !== null) {
                  arrayVigencias.push('* De ' + format(new Date(vigencias[i].dtaInicio), 'DD/MM/YYYY') + ' até ' + format(new Date(vigencias[i].dtaFim), 'DD/MM/YYYY') + ' - ' + nf.format(vigencias[i].valVigencia) + ' - Integral: ' +  nf.format(vigencias[i].valIntegral) + ' - ' + vigencias[i].grupoPrestador);
                } else {
                  arrayVigencias.push('* De ' + format(new Date(vigencias[i].dtaInicio), 'DD/MM/YYYY') + ' até ' + format(new Date(vigencias[i].dtaFim), 'DD/MM/YYYY') + ' - ' + nf.format(vigencias[i].valVigencia) + ' - ' + vigencias[i].grupoPrestador);
                }
              }
            }
          }
        }
        itens.push(Object.values({ codItem, desItem, tipoItem, tabela, capitulo, grupo, subGrupo, arrayVigencias, txtObservacao, codItemTabela, codTabela }));
        arrayVigencias = [];
      });
      return itens || [];
    } catch (error) {
      console.error(error);
    }
  }
  async consultarItensRecurso (codTabela, codItem, desItem, codTipo, indApenasUnimed) {
    let itens = [];
    let arrayVigencias = [];
    const nf = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    try {
      const urlConsultarItens = resolve('urlConsultarItens') +
      codTabela + '/' +
      codItem + '/' +
      desItem + '/' +
      codTipo + '/' +
      indApenasUnimed;
      const { data } = await this.fetch(urlConsultarItens);
      data.map(res => {
        const { codItem, desItem, tipoItem, tabela, capitulo, grupo, subGrupo, txtObservacao, vigencias, codItemTabela, codTabela, codTipoItem } = res;
        for (var i = 0; i < vigencias.length; i++) {
          if (tabela !== 'Tabela SIMPRO'){
            if (vigencias[i].indCancelado === 'S') {
              if (vigencias[i].dtaFim === null) {
                arrayVigencias.push('*Cancelada* Desde ' + format(new Date(vigencias[i].dtaInicio), 'DD/MM/YYYY') + ' - ' + nf.format(vigencias[i].valVigencia) + ' - ' + vigencias[i].grupoPrestador);
              } else {
                //arrayVigencias.push('*Cancelada* De ' + format(new Date(vigencias[i].dtaInicio), 'DD/MM/YYYY') + ' até ' + format(new Date(vigencias[i].dtaFim), 'DD/MM/YYYY') + ' - ' + nf.format(vigencias[i].valVigencia) + ' - ' + vigencias[i].grupoPrestador);
              }
            } else {
              if (vigencias[i].dtaFim === null) {
                arrayVigencias.push('* Desde ' + format(new Date(vigencias[i].dtaInicio), 'DD/MM/YYYY') + ' - ' + nf.format(vigencias[i].valVigencia) + ' - ' + vigencias[i].grupoPrestador);
              } else {
                //arrayVigencias.push('* De ' + format(new Date(vigencias[i].dtaInicio), 'DD/MM/YYYY') + ' até ' + format(new Date(vigencias[i].dtaFim), 'DD/MM/YYYY') + ' - ' + nf.format(vigencias[i].valVigencia) + ' - ' + vigencias[i].grupoPrestador);
              }
            }
          } else {
            if (vigencias[i].indCancelado === 'S') {
              if (vigencias[i].dtaFim === null) {
                if (vigencias[i].valIntegral !== null) {
                  arrayVigencias.push('*Cancelada* Desde ' + format(new Date(vigencias[i].dtaInicio), 'DD/MM/YYYY') + ' - ' + nf.format(vigencias[i].valVigencia) + ' - Integral: ' +  nf.format(vigencias[i].valIntegral) +  ' - ' + vigencias[i].grupoPrestador);
                } else {
                  arrayVigencias.push('*Cancelada* Desde ' + format(new Date(vigencias[i].dtaInicio), 'DD/MM/YYYY') + ' - ' + nf.format(vigencias[i].valVigencia) + ' - ' + vigencias[i].grupoPrestador);
                }
              } else {
                if (vigencias[i].valIntegral !== null) {
                  //arrayVigencias.push('*Cancelada* De ' + format(new Date(vigencias[i].dtaInicio), 'DD/MM/YYYY') + ' até ' + format(new Date(vigencias[i].dtaFim), 'DD/MM/YYYY') + ' - ' + nf.format(vigencias[i].valVigencia) + ' - Integral: ' +  nf.format(vigencias[i].valIntegral) + ' - ' + vigencias[i].grupoPrestador);
                } else {
                  //arrayVigencias.push('*Cancelada* De ' + format(new Date(vigencias[i].dtaInicio), 'DD/MM/YYYY') + ' até ' + format(new Date(vigencias[i].dtaFim), 'DD/MM/YYYY') + ' - ' + nf.format(vigencias[i].valVigencia) + ' - ' + vigencias[i].grupoPrestador);
                }

              }
            } else {
              if (vigencias[i].dtaFim === null) {
                if (vigencias[i].valIntegral !== null) {
                  arrayVigencias.push('* Desde ' + format(new Date(vigencias[i].dtaInicio), 'DD/MM/YYYY') + ' - ' + nf.format(vigencias[i].valVigencia) + ' - Integral: ' +  nf.format(vigencias[i].valIntegral) + ' - ' + vigencias[i].grupoPrestador);
                } else {
                  arrayVigencias.push('* Desde ' + format(new Date(vigencias[i].dtaInicio), 'DD/MM/YYYY') + ' - ' + nf.format(vigencias[i].valVigencia) + ' - ' + vigencias[i].grupoPrestador);
                }
              } else {
                if (vigencias[i].valIntegral !== null) {
                  //arrayVigencias.push('* De ' + format(new Date(vigencias[i].dtaInicio), 'DD/MM/YYYY') + ' até ' + format(new Date(vigencias[i].dtaFim), 'DD/MM/YYYY') + ' - ' + nf.format(vigencias[i].valVigencia) + ' - Integral: ' +  nf.format(vigencias[i].valIntegral) + ' - ' + vigencias[i].grupoPrestador);
                } else {
                  //arrayVigencias.push('* De ' + format(new Date(vigencias[i].dtaInicio), 'DD/MM/YYYY') + ' até ' + format(new Date(vigencias[i].dtaFim), 'DD/MM/YYYY') + ' - ' + nf.format(vigencias[i].valVigencia) + ' - ' + vigencias[i].grupoPrestador);
                }
              }
            }
          }
        }
        itens.push(Object.values({ codItem, desItem, tipoItem, tabela, capitulo, grupo, subGrupo, arrayVigencias, txtObservacao, codItemTabela, codTabela, codTipoItem }));
        arrayVigencias = [];
      });
      return itens || [];
    } catch (error) {
      console.error(error);
    }
  }
}
export default ItemTabelaApi;
